import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import { handleError } from "../error/ErrorHandler";

type BoardShortcutPostProps = {
    ctgId: number;
}

const BoardShortcutPost: FC<BoardShortcutPostProps> = ({ ctgId }) => {
    const [post, setPost] = useState([]);

    const getBoardPostByCategory = async() => {
        try {
            const res = await axios.get(`/api/board/post/by-category/${ctgId}`);
            if (res.data) setPost(res.data);
            console.log('getBoardPostByCategory', res.data);
        } catch(err) {
            handleError(err);
        }     
    };

    const getPostLink = (brdId: number) => {
        // 추후 하드코딩 제거할 것
        let menuId = 11;
        if (ctgId === 1) menuId = 11;
        if (ctgId === 2) menuId = 12;
        return `/board/${menuId}/post/${brdId}`;
    }

    useEffect(() => {
        getBoardPostByCategory();
    }, [ctgId]);

    const postItems = post.map((p, idx) => {
        if (idx < 4) {
            return (
                <a href={getPostLink(p['brdId'])} key={idx}>
                    <div className={'post-content-item'}>
                        <div className={'post-content-item-title'}>
                            {p['brdTitle']}
                        </div>
                        <div className={'post-content-item-date'}>
                            {String(p['createdDtm']).split(' ')[0]}
                        </div>
                    </div>
                </a>
            );
        }
    });

    return (
        <div className={'post-content-wrapper'}>
            <div className={'post-content-body'}>
                {postItems}
            </div>
        </div>
    );
};

export default BoardShortcutPost;
